// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fe3e2dca-2910-43f9-8446-36a33c60808e',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '1ad2a084-b550-4cf0-b94d-3327ee43e7e8',
      type: 'Container',
      name: 'progressBarSlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fe3e2dca-2910-43f9-8446-36a33c60808e'
    },
    {
      id: '4fbda945-0a67-45fc-a415-3553d62677bd',
      type: 'Sprite',
      name: 'iconTop',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Season_Pass_Icon_Top',
      parent: 'fe3e2dca-2910-43f9-8446-36a33c60808e'
    },
    {
      id: 'aebfad19-144e-4ea7-9935-3592dc94495b',
      type: 'Sprite',
      name: 'key',
      className: '',
      x: 3,
      y: -13,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Key',
      parent: 'fe3e2dca-2910-43f9-8446-36a33c60808e'
    },
    {
      id: 'c6d89d7e-f325-45da-ad19-c7cb19369ec9',
      type: 'Container',
      name: 'particleSpawnPoint',
      className: '',
      x: -0.005925,
      y: 0.226341,
      scale: {
        x: 1.001975,
        y: 0.998025
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fe3e2dca-2910-43f9-8446-36a33c60808e'
    },
    {
      id: '82f32dbc-f65f-4eb2-ab02-49799be8cd6b',
      type: 'Container',
      name: 'notificationContainer',
      className: '',
      x: 61,
      y: -31,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fe3e2dca-2910-43f9-8446-36a33c60808e'
    },
    {
      id: 'c6effd02-c423-4e9d-ae79-01c7cfdfac19',
      type: 'Container',
      name: 'timerContainer',
      className: '',
      x: 0,
      y: 51,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fe3e2dca-2910-43f9-8446-36a33c60808e'
    },
    {
      id: '20ada546-e41a-4083-8822-58809dded945',
      type: 'Container',
      name: 'timerBackgroundGreen',
      className: '',
      x: 0,
      y: 51,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fe3e2dca-2910-43f9-8446-36a33c60808e'
    },
    {
      id: 'dbbe944e-e68e-4fa6-81bf-8daf5f1fbad5',
      type: 'Sprite',
      name: 'keyWhite',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Key_White',
      parent: 'aebfad19-144e-4ea7-9935-3592dc94495b'
    },
    {
      id: '0ca42be3-ce37-421e-9702-8a45c3131166',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Notification_Dot',
      parent: '82f32dbc-f65f-4eb2-ab02-49799be8cd6b'
    },
    {
      id: 'f2408451-134a-4cee-920f-21911e453a77',
      type: 'Text',
      name: 'notificationText',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '2',
      localize: false,
      maxWidth: 36,
      maxHeight: 41,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 34,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '82f32dbc-f65f-4eb2-ab02-49799be8cd6b'
    },
    {
      id: 'ba482051-f601-4b88-a6e2-1e44581f4333',
      type: 'Sprite',
      name: 'timerBackground',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Icon_Timer_Background',
      parent: 'c6effd02-c423-4e9d-ae79-01c7cfdfac19'
    },
    {
      id: 'eb7b9121-7300-4388-b1b5-f3c827982809',
      type: 'Text',
      name: 'timerText',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1d 20h',
      localize: false,
      maxWidth: 86,
      maxHeight: 37,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#6e2009',
        stroke: 'white',
        strokeThickness: 2,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'c6effd02-c423-4e9d-ae79-01c7cfdfac19'
    },
    {
      id: 'b67a1ce2-168e-46e5-84dc-fa124ee036a5',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Menu_Icon_Join_Button',
      parent: '20ada546-e41a-4083-8822-58809dded945'
    },
    {
      id: '68a33830-9876-426c-a0f3-62944a95c73f',
      type: 'Text',
      name: 'openText',
      className: 'upperCase_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Claim',
      localize: true,
      maxWidth: 83,
      maxHeight: 37,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x006f0d',
        strokeThickness: 2,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '20ada546-e41a-4083-8822-58809dded945'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  animations: [
    {
      id: '55d5e3da-902e-4f89-805b-524732a19a14',
      name: 'Full_Bar_Idle',
      playingSpeed: 1,
      totalDuration: 2000,
      blocks: [
        {
          id: '80611adc-fd8f-4510-b121-e7a4bd7ccc8a',
          type: 'Setter',
          name: 'key2Alpha',
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'key_2',
          disabled: false
        },
        {
          id: 'ce8e0e0f-4032-4fe2-b654-69c8076ccba5',
          type: 'Tween',
          name: 'keyScale',
          duration: 1000,
          track: 3,
          target: {
            scale: {
              x: 0.98,
              y: 1.02
            }
          },
          startAt: 0,
          sourceName: 'key',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'ab87d4e1-a4b3-45ba-ada9-f69e78cabbe2',
          type: 'Tween',
          name: 'keyPosition_1',
          duration: 1000,
          track: 4,
          target: {
            y: -18
          },
          startAt: 0,
          sourceName: 'key',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '45f6ebc5-8723-43b5-902b-6555982d44b1',
          type: 'Setter',
          name: 'keyWhiteAlpha',
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 1,
          sourceName: 'keyWhite',
          disabled: false
        },
        {
          id: 'b9b2da58-d2c2-4cfb-a93d-715926080537',
          type: 'Tween',
          name: 'keyWhiteAlpha',
          duration: 400,
          track: 6,
          target: {
            alpha: 0.3
          },
          startAt: 600,
          sourceName: 'keyWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c9d41748-d816-43ff-ac02-3e2aebca1cc1',
          type: 'Tween',
          name: 'keyRotation_1',
          duration: 250,
          track: 5,
          target: {
            angle: -5
          },
          startAt: 750,
          sourceName: 'key',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b12e4bd6-58e4-45b7-8dae-2bb757de0c36',
          type: 'Tween',
          name: 'keyWhiteAlpha_1',
          duration: 800,
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 1000,
          sourceName: 'keyWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '09ff20e3-c985-4321-9a18-cdfa67c2b878',
          type: 'Tween',
          name: 'keyRotation',
          duration: 100,
          track: 5,
          target: {
            angle: 5
          },
          startAt: 1000,
          sourceName: 'key',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: '2fd634c5-b361-4955-98d2-1491c6db2db7',
          type: 'Tween',
          name: 'keyPosition',
          duration: 1000,
          track: 4,
          target: {
            y: -13
          },
          startAt: 1000,
          sourceName: 'key',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '637541f0-c296-4670-a24d-fe1b4c134c07',
          type: 'Tween',
          name: 'keyScale_1',
          duration: 1000,
          track: 3,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1000,
          sourceName: 'key',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'd3cd9b16-f165-4384-bc3c-41cc1d5ba967',
          type: 'Tween',
          name: 'keyRotation_2',
          duration: 50,
          track: 5,
          target: {
            angle: -2
          },
          startAt: 1100,
          sourceName: 'key',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b993beae-a9b7-46f8-8e6c-653065e8c99d',
          type: 'Tween',
          name: 'keyRotation_3',
          duration: 50,
          track: 5,
          target: {
            angle: 1
          },
          startAt: 1150,
          sourceName: 'key',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'd73218fe-1835-458d-93e6-4e0d1b5bb05a',
          type: 'Tween',
          name: 'keyRotation_4',
          duration: 25,
          track: 5,
          target: {
            angle: 0
          },
          startAt: 1200,
          sourceName: 'key',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    },
    {
      id: '08cfa53e-e8f2-4e21-a1f4-e215e4750c1a',
      name: 'Receiving_New_Key',
      playingSpeed: 1,
      totalDuration: 1000,
      blocks: [
        {
          id: 'e22324c0-1981-4b74-b1bd-80405bb9e98d',
          type: 'Tween',
          name: 'keyScale_2',
          duration: 50,
          track: 1,
          target: {
            scale: {
              x: 1.06,
              y: 0.93
            }
          },
          startAt: 0,
          sourceName: 'key',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '8e37952a-729c-4d4a-bebe-919a98d59562',
          type: 'Tween',
          name: 'keyPosition_2',
          duration: 200,
          track: 2,
          target: {
            y: -8
          },
          startAt: 0,
          sourceName: 'key',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '28ae388c-5391-44e0-84b5-4d95252ca970',
          type: 'Tween',
          name: 'keyWhiteAlpha_2_1',
          duration: 100,
          track: 3,
          target: {
            alpha: 0.3
          },
          startAt: 0,
          sourceName: 'keyWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a36b3465-df26-42e9-9454-0dc4f4bba1ba',
          type: 'Setter',
          name: 'SFX_Adding_Event_Token',
          track: 5,
          target: {},
          startAt: 50,
          sourceName: 'root',
          disabled: false
        },
        {
          id: 'bd06d711-e142-4810-872c-ceea32c0de27',
          type: 'Setter',
          name: 'FXPART_Season_Pass_Key_Particles',
          track: 4,
          target: {},
          startAt: 50,
          sourceName: 'particleSpawnPoint',
          disabled: false
        },
        {
          id: '7938785e-2bc2-48f3-b938-2f3ac4cf83e5',
          type: 'Tween',
          name: 'keyScale_3',
          duration: 150,
          track: 1,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 50,
          sourceName: 'key',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '0094be55-1f0b-4ab2-add3-55b56e50ace0',
          type: 'Tween',
          name: 'keyWhiteAlpha_2',
          duration: 900,
          track: 3,
          target: {
            alpha: 0
          },
          startAt: 100,
          sourceName: 'keyWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '1d5a4bfa-50a2-4142-b4dc-40cda11eeb30',
          type: 'Tween',
          name: 'keyPosition_3',
          duration: 200,
          track: 2,
          target: {
            y: -27
          },
          startAt: 200,
          sourceName: 'key',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '3140d190-218a-42da-a858-440e9713fbe2',
          type: 'Tween',
          name: 'keyScale_4_1',
          duration: 300,
          track: 1,
          target: {
            scale: {
              x: 0.97,
              y: 1.03
            }
          },
          startAt: 200,
          sourceName: 'key',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '47bcbf93-3cd8-417d-a4d5-81ac5f5d2eb5',
          type: 'Tween',
          name: 'keyPosition_4',
          duration: 200,
          track: 2,
          target: {
            y: -8
          },
          startAt: 400,
          sourceName: 'key',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '77b8eea4-9102-4a07-84d4-ed323567084b',
          type: 'Tween',
          name: 'keyScale_4',
          duration: 150,
          track: 1,
          target: {
            scale: {
              x: 1.03,
              y: 0.97
            }
          },
          startAt: 500,
          sourceName: 'key',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '71bd58b2-5ee2-4481-bd8b-d654552d67ef',
          type: 'Tween',
          name: 'keyPosition_5',
          duration: 400,
          track: 2,
          target: {
            y: -13
          },
          startAt: 600,
          sourceName: 'key',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '5639ebce-705a-40c4-afbb-0e29d9d62b4f',
          type: 'Tween',
          name: 'keyScale_5',
          duration: 350,
          track: 1,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 650,
          sourceName: 'key',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class SeasonPassMenuIconLayout {
  static raw = raw;
  root!: Container;
  progressBarSlot!: Container;
  iconTop!: Sprite;
  key!: Sprite;
  particleSpawnPoint!: Container;
  notificationContainer!: Container;
  timerContainer!: Container;
  timerBackgroundGreen!: Container;
  keyWhite!: Sprite;
  notificationText!: Text;
  timerBackground!: Sprite;
  timerText!: Text;
  openText!: Text;
  upperCase_SPL!: (Text)[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class Full_Bar_Idle {
  Layout: {
    key_2: object;
    key: object;
    keyWhite: object;
  };

  BlockTypeByName: {
    key2Alpha: object;
    keyScale: object;
    keyPosition_1: object;
    keyWhiteAlpha: object;
    keyWhiteAlpha: object;
    keyRotation_1: object;
    keyWhiteAlpha_1: object;
    keyRotation: object;
    keyPosition: object;
    keyScale_1: object;
    keyRotation_2: object;
    keyRotation_3: object;
    keyRotation_4: object;
  };

  flowData = raw.animations[0];
}

export abstract class Receiving_New_Key {
  Layout: {
    key: object;
    keyWhite: object;
    root: object;
    particleSpawnPoint: object;
  };

  BlockTypeByName: {
    keyScale_2: object;
    keyPosition_2: object;
    keyWhiteAlpha_2_1: object;
    SFX_Adding_Event_Token: object;
    FXPART_Season_Pass_Key_Particles: object;
    keyScale_3: object;
    keyWhiteAlpha_2: object;
    keyPosition_3: object;
    keyScale_4_1: object;
    keyPosition_4: object;
    keyScale_4: object;
    keyPosition_5: object;
    keyScale_5: object;
  };

  flowData = raw.animations[1];
}
